import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import '@/assets/css/index.less';
import VueCropper from 'vue-cropper'

import Storage from 'vue-ls'
// vue-ls 的配置
const storageOptions = {
  namespace: 'vue_',   
  name: 'ls',          // 变量名称使用方式：Vue.ls 或 this.$ls
  storage: 'local'    // 存储方式: session, local, memory
}

import { VueAxios } from '@/utils/request'

Vue.config.productionTip = false
Vue.use(Storage, storageOptions)
Vue.use(VueAxios)
Vue.use(Antd)
Vue.use(VueCropper)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
